import React from 'react';

// The logo file's icon and wordmark are both dark green, which disappears
// against the hero's dark background before the navbar scrolls to its white
// state. variant="light" inverts it to a white silhouette for that case.
const Logo = ({ variant = 'dark', className = '' }) => {
  return (
    <img
      src="/static/images/serenoly-logo.png"
      alt="Serenoly"
      className={`h-9 md:h-11 w-auto ${className}`}
      style={variant === 'light' ? { filter: 'brightness(0) invert(1)' } : undefined}
    />
  );
};

export default Logo;
